// Google Analytics 4 Integration

export const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || 'G-XXXXXXXXXX';

// Initialize Google Analytics
export const initGA = () => {
    if (typeof window !== 'undefined' && GA_MEASUREMENT_ID !== 'G-XXXXXXXXXX') {
        // Load gtag script
        const script = document.createElement('script');
        script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
        script.async = true;
        document.head.appendChild(script);

        // Initialize gtag
        window.dataLayer = window.dataLayer || [];
        function gtag() {
            window.dataLayer.push(arguments);
        }
        window.gtag = gtag;
        gtag('js', new Date());
        gtag('config', GA_MEASUREMENT_ID, {
            page_path: window.location.pathname,
        });

        console.log('Google Analytics initialized');
    }
};

// Track page views
export const trackPageView = (url) => {
    if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('config', GA_MEASUREMENT_ID, {
            page_path: url,
        });
    }
};

// Track custom events
export const trackEvent = (eventName, eventParams = {}) => {
    if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('event', eventName, eventParams);
    }

    // Also log to console in development
    if (process.env.NODE_ENV === 'development') {
        console.log('GA Event:', eventName, eventParams);
    }
};

// Predefined event trackers
export const trackButtonClick = (buttonName, location) => {
    trackEvent('button_click', {
        button_name: buttonName,
        location: location,
    });
};

export const trackDownloadClick = (source) => {
    trackEvent('download_app_click', {
        source: source,
    });
};

export const trackFormSubmit = (formName, success = true) => {
    trackEvent('form_submit', {
        form_name: formName,
        success: success,
    });
};

export const trackNewsletterSignup = (source) => {
    trackEvent('newsletter_signup', {
        source: source,
    });
};

export const trackScrollDepth = (depth) => {
    trackEvent('scroll_depth', {
        depth_percentage: depth,
    });
};

// Track scroll depth automatically
let scrollDepthTracked = {
    25: false,
    50: false,
    75: false,
    100: false,
};

export const initScrollTracking = () => {
    window.addEventListener('scroll', () => {
        const scrollPercentage = Math.round(
            (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100
        );

        Object.keys(scrollDepthTracked).forEach((depth) => {
            if (scrollPercentage >= depth && !scrollDepthTracked[depth]) {
                scrollDepthTracked[depth] = true;
                trackScrollDepth(depth);
            }
        });
    });
};

export default {
    initGA,
    trackPageView,
    trackEvent,
    trackButtonClick,
    trackDownloadClick,
    trackFormSubmit,
    trackNewsletterSignup,
    initScrollTracking,
};
